export default __webpack_public_path__ + "media/images/react_icons/rooftop-9ae034b98df5117277c3f011dad53d2e.svg";